import React from 'react';
import type { WalletBrand } from '../../lib/wallet';

/**
 * WalletBadge — a small branded mark for a wallet (accent square + initial).
 * Used in the picker rows and the connect-modal header. A stand-in for a real
 * logo asset; swap the inner content for an <img> when brand logos are added.
 */
export const WalletBadge: React.FC<{ wallet: WalletBrand; size?: number }> = ({ wallet, size = 40 }) => (
  <div
    className="flex flex-shrink-0 items-center justify-center rounded-lg font-heading-3 text-white"
    style={{ width: size, height: size, backgroundColor: wallet.accent, fontSize: size * 0.5 }}
    aria-hidden
  >
    {wallet.initial}
  </div>
);
